import classNames from 'classnames';
import './styles.scss';

interface DividerProps {
  className?: string;
}

const Divider = ({ className }: DividerProps) => {
  return <div className={classNames('divider', className)} />;
};

export default Divider;
